import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  readonly title: string;
  readonly caption?: string;
};

export function PageSectionHeader({ title, caption }: Props) {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
        <Typography variant="h3" sx={{ fontSize: { xs: 26, md: 30 } }}>
          {title}
        </Typography>
      </Stack>
      {caption && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0.5, ml: 0 }}
        >
          {caption}
        </Typography>
      )}
    </Box>
  );
}
